import React from 'react'
import Zoom from "react-reveal"

import { AboutCards, Clients } from './About.constant'
import { StyledAbout } from './About.style'
// import "../assets/style/about.css"

import Triangle from "../assets/icons/Triangle"
import VideoAbout from "../../../assets/images/about.mp4"

export default function About() {
  return (
    <StyledAbout>
      <header className='header-about' >
      <video className='about-video' src={VideoAbout} autoPlay loop muted ></video>
        <div className='shadow'></div>
        <div className='container'>
          <div className='main-about'>
            <h1>About us</h1>
            <p>The most easy-to-use ELD device and application</p>
          </div>
        </div>
      </header>
      {/* <div className='navbar-wrapper'>
        <Navbar />
      </div> */}

      <div className='section-about'>
        <div className='container'>
          <div className='about-cards'>

            {
              AboutCards.map((item) => (
                <Zoom left cascade>
                  <div className='card' key={item.id}>
                    <div className='card-img'>
                      <img src={item.img} alt="aboutCardImg" />
                    </div>
                    <div className='card-info'>
                      {item.icon}
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                    </div>
                  </div>
                </Zoom>

              ))
            }
          </div>
        </div>
      </div>

      <div className='section-clients'>
        <div className='container' >
          <div className='clients'>
            <h1 className='redline'><span></span>Happy Clients</h1>
            <div className='client-cards'>
              {
                Clients.map((item) => (
                  <Zoom right>
                    <div className='card' key={item.id}>
                      <div className='card-top'>
                        <div className='card-img'>
                          <img src={item.img} alt={`${item.img}`} />
                        </div>
                        <div className='card-info'>
                          <h3>{item.name}</h3>
                          <p>{item.job}</p>
                        </div>
                      </div>

                      <div className='card-text'>
                        <Triangle className="triangle" />
                        <p>{item.text}</p>
                      </div>
                    </div>
                  </Zoom>

                ))
              }
            </div>
          </div>
        </div>
      </div>

    </StyledAbout>
  )
}
